import { scaleQuantize } from "d3-scale";

export default function stateFillScale(max) {
  return scaleQuantize()
    .domain([0, Math.max(1, max)])
    .range(["#eff6ff", "#dbeafe", "#bfdbfe", "#93c5fd", "#60a5fa", "#3b82f6", "#2563eb", "#1d4ed8"]);
}